import type { PasswordMode, PasswordTypeConfig, TypeConfig } from "@/models/custom-fields";

/** The password mode of a `password` field, which the `type_config` stores as `encrypted` and `unlock`. */
export function passwordModeOf(typeConfig: TypeConfig | null | undefined): PasswordMode | undefined {
  const properties = (typeConfig as Partial<PasswordTypeConfig> | null | undefined)?.properties;
  if (!properties) return undefined;
  if (!properties.encrypted?.const) return "plain";
  return properties.unlock?.const === "every_access" ? "always_encrypted" : "encrypted";
}

/** The `type_config` to send for a password mode. */
export function toPasswordTypeConfig(mode: PasswordMode): PasswordTypeConfig {
  if (mode === "plain") return { properties: { encrypted: { const: false } } };
  return { properties: { encrypted: { const: true }, unlock: { const: mode === "always_encrypted" ? "every_access" : "session" } } };
}
